import { render, staticRenderFns } from "./DonateCardCountdown.vue?vue&type=template&id=5da01d0b&scoped=true&"
import script from "./DonateCardCountdown.vue?vue&type=script&lang=js&"
export * from "./DonateCardCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da01d0b",
  null
  
)

export default component.exports